import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from '../App';
import { useGetOwnProfileQuery } from '../api/UserApi';
import { useLoggedIn } from '../hooks/useLoggedIn';
import { LoginState } from '../state/loginSlice';
import { IconButton } from './IconButton';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './LoginStatusAvatar.module.css';
import { IconLogin } from './QuirkIcons';
import { ProfilePic } from './ProfilePic';
import { SkeletonLoader } from './SkeletonLoader';
export const LoginStatusAvatar = ({ label }: { label?: string }) => {
	const state: LoginState = useSelector<RootState, LoginState>(state => state.login);
	const { realUser } = useLoggedIn();
	const history = useHistory();
	const { data: user } = useGetOwnProfileQuery(state?.user._id, { skip: !realUser });
	const avatarClick = (e: CustomEvent) => {
		history.push(realUser ? `/main/settings/profile/` : `/main/settings/login`);
	};
	return (
		<>
			<IconButton
				label={label}
				onClick={avatarClick}
				icon={
					<div className={styles.avatarContainer}>
						<span className="iconCircleGray">
							<SkeletonLoader height={29}>
								{realUser && user !== undefined && (
									<ProfilePic user={user} size="avatar" disableClick />
								)}
								{!realUser && <IconLogin />}
							</SkeletonLoader>
						</span>
						{!realUser && <span>Login</span>}
					</div>
				}
			/>
		</>
	);
};
